export interface FamilyPhoto {
  src: string
  alt: string
  caption: string
}

export const familyTagline = 'We Build Happiness, You Swim In It'

export const familyPhotos: FamilyPhoto[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/oggoiHtN98JeE4Ubmx6r66/heylloyd-image-1789955768305.png',
    alt: 'Two young A&J crew members in company shirts working along the edge of a pool mid-project',
    caption: 'On the job — same shirts, same family, every project.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rqmzjjQc11FrXmynWiSPHB/aj5.png',
    alt: 'Boy holding an A&J Pool Plaster sign in front of a finished pool with waterfall and travertine deck',
    caption: 'The next generation, already proud of the name.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/un8qsQ3mkYg75bjBiUbo7U/aj6.png',
    alt: 'Five kids smiling together in a swimming pool on a summer day',
    caption: 'This is the part we actually build for.',
  },
]
